'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageAsset = undefined;

var _themeProvider = require('@spp/theme-provider');

var _Image = require('./Image');

var _Image2 = _interopRequireDefault(_Image);

var _ImageAsset = require('./ImageAsset');

var _ImageAsset2 = _interopRequireDefault(_ImageAsset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ImageAsset = _ImageAsset2.default;
exports.default = (0, _themeProvider.themer)('@spp/ui-image')(_Image2.default);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-image/lib/cjs/index.js
 ** module id = 71
 ** module chunks = 1
 **/